<div class="mobile-brand-bar">
  <app-svg-loader *ngIf="currentTheme === 'dark-theme'" height="24px"
    url="assets/logos/tail-one-logo-white.svg?key=1"></app-svg-loader>
  <app-svg-loader *ngIf="currentTheme === 'light-theme'" height="24px"
    url="assets/logos/tail-one-logo-dark.svg?key=1"></app-svg-loader>
  <div class="cta-wrapper">
    {{ctaText}}
  </div>
</div>

<app-split-page-wrapper>
  <div left>
    <div class="brand-element">
      <div class="logo-wrapper">
        <div class="logo-ball"></div>
        <app-svg-loader *ngIf="currentTheme === 'dark-theme'" height="34px"
          url="assets/logos/tail-one-logo-white.svg?key=2"></app-svg-loader>
        <app-svg-loader *ngIf="currentTheme === 'light-theme'" height="34px"
          url="assets/logos/tail-one-logo-dark.svg?key=2"></app-svg-loader>
      </div>
      <div class="cta-wrapper">
        {{ctaText}}
      </div>
    </div>
  </div>
  <div right>

    <div class="auth-form-wrapper">

      <h2>Sign Up</h2>

      <div class="field-row">
        <app-base-input id="firstName" placeholder="First Name" [(ngModel)]="firstName" type="text" isFluid="true"
          autocomplete="off"></app-base-input>
        <app-base-input id="lastName" placeholder="Last Name" [(ngModel)]="lastName" type="text" isFluid="true"
          autocomplete="off"></app-base-input>
      </div>

      <app-base-input id="newEmail" placeholder="email" mb="14px" [(ngModel)]="email" type="email" isFluid="true"
        autocomplete="email"></app-base-input>

      <app-password-strength-input id="newPassword" placeholder="password" mb="14px" [(ngModel)]="password"
        (onEnter)="signUp()" (focusEvent)="resetError()" isFluid="true"
        autocomplete="new-password"></app-password-strength-input>

      <app-alert-message *ngIf="errorMessage" type="error" mb="24px">{{errorMessage}}</app-alert-message>

      <app-primary-btn (click)="signUp()" mb="24px"
        [disabled]="isRegistering || !firstName?.trim() || !lastName?.trim() || !email?.trim() || !password?.trim()"
        gradient="true">
        <span *ngIf="!isRegistering">Submit</span>
        <app-spinner variant="btn-spinner" *ngIf="isRegistering" size="20px"></app-spinner>
      </app-primary-btn>
      <button class="google-auth-btn" (click)="signInWithGoogle()">
        <div class="icon">
          <app-svg-loader height="18px" url="assets/third-party-logos/logo-google.svg"></app-svg-loader>
        </div>
        <div class="text">Continue with Google</div>
      </button>

      <div class="terms-wrap">
        By continuing you agree to the
        <a href="https://tailone.ai/terms-of-use" target="blank">Terms of Use</a> & 
        <a href="https://tailone.ai/privacy-policy" target="blank">Privacy Policy</a>
      </div>

      <div class="auth-link-wrap bordered right mt24">
        <a class="link" [routerLink]="['/login']">I have an account</a>
      </div>

    </div>
  </div>

</app-split-page-wrapper>
